import { render } from "./ManifestoPrintable.vue?vue&type=template&id=6c897d3a"
import script from "./ManifestoPrintable.vue?vue&type=script&lang=js"
export * from "./ManifestoPrintable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__